import Axios from "axios";
import {initPhoneForm} from "./form";
import {loading, stopLoading} from "../../helpers/loading";
import {handleAjaxSuccess} from "../../helpers/swalHelper";
import handleAjaxError from "../../helpers/handleAjaxError";

function initSourcePhonesCreate() {

	const phoneForm = initPhoneForm(document.querySelector('.phone-form'));

	document.querySelector('.create-phone-button').onclick = createNewPhone;

	function createNewPhone() {
		const data = phoneForm.inputs();

		phoneForm.clearFeedbacks();

		loading();

		Axios.post(phoneForm.postUrl(), data)
			.then(handleAjaxSuccess)
			.catch(handleAjaxError)
			.finally(stopLoading)
	}
}

export {initSourcePhonesCreate}
